/*
 *###############################################################################
 *Module Name                   : CustomerBundleMaster.js                       #
 *Purpose of the Module         :                                               #
 *Description of the Module     :                                               #
 *Original Author               : Bihini Amarasinghe                            #
 *Date                          : Friday, April 21st 2022                       #
 *Copyright © 2021 myPOS Software Solution (pvt Ltd.)                           #
 *###############################################################################
 */

import React, { useState, useEffect, useContext } from "react"
import { MetaTags } from "react-meta-tags"
import { Card, Col, Container, Row, CardBody } from "reactstrap"

//**Importing required componant files   */
import Breadcrumb from "components/Common/Breadcrumb"
import DPTopToolBar from "framework/widgets/DPTopToolBar"
import CustomerBundleMasterContent from "./CustomerBundleMasterContent"
import DPInfoBox from "framework/layout/DPInfoBox"
import { Text, Numeric, DecimalValidation } from "../../../framework/validators/TextValidation"
import DPAlert from "../../../framework/widgets/DPAlert"
import DPLoadingAlert from "framework/widgets/DPLoadingAlert"
import DPPermission from "framework/widgets/DPPermission"
import * as XLSX from "xlsx"
import DPPrintOption from "framework/widgets/DPPrintOptions"
//**End Importing required componant files */

import { Context } from '../../../app-contexts/CommonContexts';
import { useHistory } from 'react-router-dom';
import { CustomerBundleDetailsGetData, DeleteCustomerBundleDetails, SaveCustomerBundleDetails, getCusCompany, getCusDesingnation, getCusGroups, getCusProfession } from "./CustomerBundleController"

const CustomerBundleMaster = props => {

  let history = useHistory();
  //*** User input related states */
  const [strCode, SetCode] = useState("") // Set Bundle Code
  const [strBundleName, SetBundleName] = useState("") //Set Bundle Name
  const [IsActiveEbill, SetActiveEbill] = useState(false) //Set Ebill Active state
  const [IsActiveMobile, SetActiveMobile] = useState(false) //Set Mobile App Active state
  const [IsActiveStatus, SetActiveStatus] = useState(true) //Set Status Active state
  const [Points, setPoints] = useState(0)
  const [menuCode, SetMenuCode] = useState("")
  const [allCompany, setAllCompany] = useState([])
  const [customergroups, setCustomerGroups] = useState([])
  const [allProfession, setAllProfession] = useState([])
  const [allDesignation, setAllDesignation] = useState([])
  const [company, setcompanyBase] = useState([])
  const [customer, setcustomerBase] = useState([])
  const [profession, setprofessionBase] = useState([])
  const [designation, setdesignationBase] = useState([])
  const [gender, setgender] = useState([])
  const [genderBase, setgenderBase] = useState([
    {
      label: "Male",
      value: "M",
    },
    {
      label: "Female",
      value: "F",
    },
  ])

  //*** End User input related states */

  //*** User Activity related states*/
  const [show, setShow] = useState(false)
  const [AlertMsg, setAlertMsg] = useState("")
  const [AlertColor, setAlertColor] = useState("")
  const [modal_xlarge, setmodal_xlarge] = useState(false)
  const [disabled, setDisabled] = useState(false)
  const [disabledCode, setDisabledCode] = useState(false)
  const [saveEnable, setSaveEnable] = useState(true)
  const [crEnable, setCrEnable] = useState(false)
  const [crBy, setCrBy] = useState("")
  const [mdBy, setMdBy] = useState("")
  const [crDate, setCrDate] = useState("")
  const [mdDate, setMdDate] = useState("")
  const [deleteEnable, SetDeleteEnable] = useState(false)
  const [Reason, setReason] = useState("Created")
  const [editEnable, SetEditEnable] = useState(false)
  //*** End User activity related staes */

  //Alert Parameters
  const [sweetAlertShow, setsweetAlertShow] = useState(false)
  const [AlertDescription, setAlertDescription] = useState(false)
  const [AlertConfirmOption, setAlertConfirmOption] = useState(0)
  const [ErrorMsg, setErrorMsg] = useState("")
  const [addNew, SetAddNew] = useState(true)

  //*****Menu Rights Start*/
  const [menuAccess, SetMenuAccess] = useState(false)
  const [menuCreate, SetMenuCreate] = useState(false)
  const [menuDelete, SetMenuDelete] = useState(false)
  const [menuModify, SetMenuModify] = useState(false)
  const [menuPrint, SetMenuPrint] = useState(false)
  const [menuProcess, SetMenuProcess] = useState(false)
  const [menuName, SetMenuName] = useState("")
  const [parentName, SetParentName] = useState("")
  const [LocationCode, setLocationCode] = useState("")
  const [LogUserType, setLogUserType] = useState("")
  const [LogCompanyCode, setLogCompanyCode] = useState("")
  //*****Menu Rights End */

  /**********Loading Alert */
  const [loadingAlert, SetLoadingAlert] = useState(false)
  const [loadingAlertTitle, SetLoadingAlerttitle] = useState("")
  /**********End Loading Alert */

  //autocode generation related newly added code
  const [codeButton, setCodeButton] = useState(true)
  const [searchdisabled, setSearchdisabled] = useState(false)
  const [nullCode, setNullCode] = useState(false)
  const [autoCode, setAutoCode] = useState(false)

  //User Permission related usestates
  const [permissionAlertShow, setPermissionAlertShow] = useState(false)
  const [permissionAlertTitle, setPermissionAlertTitle] = useState("")
  const [permissionReasonShow, setPermissionReasonShow] = useState(false)
  const [permissionName, setPermissionName] = useState("")
  const [permissionPassword, setPermissionPassword] = useState("")
  const [permissionNameDisable, setPermissionNameDisable] = useState(false)

  const [printoptionShow, setprintoptionShow] = useState(false)
  var time = process.env.REACT_APP_ALERTTIMEOUT
  const [valueUpload, setvalueUpload] = useState("")
  const [items, setItems] = useState([])
  const [Excelitems, setExcelItems] = useState([])
  const [helpUrl, setHelpUrl] = useState("")

  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")


  var time = process.env.REACT_APP_ALERTTIMEOUT


  //**Get File Details */

  //import from contexts
  const {
    isHeadOffice, getMenuDetails, masterAuditLog, getSelectedMasterPermissions, fetchAutoCode, addtoFavourite
  } = useContext(Context);
  //import from contexts

  useEffect(async () => {
    var obj = JSON.parse(localStorage.getItem("authUser"))
    var LogUserType = obj[2]
    var menuDetail = await getMenuDetails(window.location.pathname)
    var menu = menuDetail && menuDetail.menuTag ? menuDetail.menuTag : history.push('/dashboard');
    var parentname = menuDetail?.parentName
    SetParentName(parentname)
    var LocationCode = obj[3]
    var CompanyCode = obj[5]
    setLocationCode(LocationCode)
    setLogUserType(LogUserType)
    setLogCompanyCode(CompanyCode)

    var responseData = await getSelectedMasterPermissions(LogUserType, menu)

    if (!responseData.strMenuAccessRight) {
      history.push('/dashboard')
    }

    SetMenuAccess(responseData.strMenuAccessRight)
    SetMenuCreate(responseData.strMenuCreateRight)
    SetMenuDelete(responseData.strMenuDeleteRight)
    SetMenuModify(responseData.strMenuModifyRight)
    SetMenuPrint(responseData.strMenuPrintRight)
    SetMenuProcess(responseData.strMenuProcessRight)
    SetMenuName(responseData.strMenuName)
    SetMenuCode(responseData.strMenuTag)
    setPermissionReasonShow(responseData.strMenuReasonShow)
    setHelpUrl(responseData.strHelpUrl)

    var autoCodeRes = await fetchAutoCode(menu)

    if (autoCodeRes.nullCode == false) {
      setAutoCode(autoCodeRes.autoCode)
    } else {
      setNullCode(true)
      setAutoCode("")
    }
  }, [strCode])

  // AuditLog
  useEffect(async () => {
    var obj = JSON.parse(localStorage.getItem("authUser"))
    var LogUserType = obj[2]
    var LocationCode = obj[3]
    var CompanyCode = obj[5]
    var menuDetail = await getMenuDetails(window.location.pathname)
    var menu = menuDetail && menuDetail.menuTag ? menuDetail.menuTag : history.push("/dashboard")

    await masterAuditLog(menu, LogUserType, LocationCode, CompanyCode) //masterfile access log
  }, [])


  useEffect(() => {

    /**************get company data */
    async function getCompany() {
      const response = await getCusCompany();
      if (response.success) {
        setAllCompany(response.data)
      } else {

      }
    }

    //*************getcustomer groups data */
    async function getCustomerGroup() {
      const response = await getCusGroups()
      if (response.success) {
        setCustomerGroups(response.data)
      }
    }

    /**************get designation data */
    async function getDesignation() {
      const response = await getCusDesingnation()
      if (response.success) {
        setAllDesignation(response.data)
      }
    }

    /**************get profession data */
    async function getProfession() {
      const response = await getCusProfession()
      if (response.success) {
        setAllProfession(response.data)
      }
    }

    getCompany()
    getCustomerGroup()
    getDesignation()
    getProfession()
  }, [])


  const readExcel = file => {
    const promise = new Promise((resolve, reject) => {
      const fileReader = new FileReader()
      fileReader.readAsArrayBuffer(file)

      fileReader.onload = e => {
        const bufferArray = e.target.result

        const wb = XLSX.read(bufferArray, { type: "buffer" })

        const wsname = wb.SheetNames[0]

        const ws = wb.Sheets[wsname]

        const data = XLSX.utils.sheet_to_json(ws)
        setExcelItems(data)
        resolve(data)
      }

      fileReader.onerror = error => {
        reject(error)
      }
    })

    promise.then(d => {
      setItems(d)
    })
  }

  //*** Get and Set values when user search code */
  async function getData(searchData) {

    if (searchData == "") return

    if (validateSpecialCharacters(searchData) == true) {
      SetCode("")
      return
    }

    SetLoadingAlert(true)
    SetLoadingAlerttitle("Fetching...")

    const result = await CustomerBundleDetailsGetData(searchData);

    SetLoadingAlert(false)

    if (result.success == true) {

      SetBundleName(result.data.description)
      SetActiveEbill(result.data.ebill != "" ? true : false)
      SetActiveMobile(result.data.app != "" ? true : false)
      SetActiveStatus(result.data.status != "" ? true : false)
      setPoints(result.data.points)
      setCrBy(result.data.createdBy)
      setCrDate(result.data.createdDate)
      setMdBy(result.data.modifyBy)
      setMdDate(result.data.modifyDate == "1900-01-01T00:00:00" ? "" : result.data.modifyDate)

      var newCompany = []
      var newCustomer = []
      var newProfession = []
      var newDesignation = []
      var newGender = []


      result.data.company.map(item => {
        allCompany.find(x => {
          if (x.value == item.bunD_VALUE) {
            newCompany.push(x)
          }
        })
      })

      result.data.customer.map(item => {
        customergroups.find(x => {
          if (x.value == item.bunD_VALUE) {
            newCustomer.push(x)
          }
        })
      })

      result.data.profession.map(item => {
        allProfession.find(x => {
          if (x.value == item.bunD_VALUE) {
            newProfession.push(x)
          }
        })
      })

      result.data.designation.map(item => {
        allDesignation.find(x => {
          if (x.value == item.bunD_VALUE) {
            newDesignation.push(x)
          }
        })
      })

      result.data.gender.map(item => {
        genderBase.find(x => {
          if (x.value == item.bunD_VALUE) {
            newGender.push(x)

          }
        })
      })

      setcompanyBase(newCompany)
      setcustomerBase(newCustomer)
      setprofessionBase(newProfession)
      setdesignationBase(newDesignation)
      setgender(newGender)


      SetAddNew(false)
      setDisabled(true)
      setDisabledCode(true)
      setSaveEnable(false)
      SetDeleteEnable(true)
      setSearchdisabled(true)
      setReason("Updated")
      SetEditEnable(true)
      setCrEnable(true)

    } else {
      if (nullCode == false) {
        setDisabledCode(true)
        displayAlertMessage('success', "Record Not Found !")
        SetCode("")
      } else {
        displayAlertMessage('success', "Record Not Found !")
      }
    }
  }

  //*** End useEffect */


  function tog_xlarge() {
    setmodal_xlarge(!modal_xlarge)
    removeBodyCss()
  }

  //removebodyCss function
  function removeBodyCss() {
    document.body.classList.add("no_padding")
  }

  //save button function
  const handlesave = async e => {


    //set autogenerate code to as CODE just for display purpuse
    var newCode = ""
    if (addNew == true && nullCode == false) {
      SetCode(autoCode)
      newCode = autoCode
    } else {
      newCode = strCode
    }

    if (strCode == "" && nullCode == true) {
      displayAlertMessage("danger", "Please Enter  Code !")
      return
    }
    if (strBundleName == "") {
      displayAlertMessage("danger", "Please Enter Bundle Name")
      return
    }

    var CustomerDetails = []

    customer.map((item, index) => {
      CustomerDetails.push({
        "BUND_CODE": newCode,
        "BUND_TYPE": "CUS",
        "BUND_VALUE": item.value,
      })
    })

    profession.map((item, index) => {
      CustomerDetails.push({
        "BUND_CODE": newCode,
        "BUND_TYPE": "PRO",
        "BUND_VALUE": item.value,
      })
    })

    company.map((item, index) => {
      CustomerDetails.push({
        "BUND_CODE": newCode,
        "BUND_TYPE": "COM",
        "BUND_VALUE": item.value,
      })
    })

    designation.map((item, index) => {
      CustomerDetails.push({
        "BUND_CODE": newCode,
        "BUND_TYPE": "DESIG",
        "BUND_VALUE": item.value,
      })
    })

    gender.map((item, index) => {
      CustomerDetails.push({
        "BUND_CODE": newCode,
        "BUND_TYPE": "GEN",
        "BUND_VALUE": item.value,
      })
    })

    const customerBundle = {
      strCode: newCode,
      strDesc: strBundleName,
      CustomerDetails: CustomerDetails,
      intEbill: IsActiveEbill ? 1 : 0,
      intApp: IsActiveMobile ? 1 : 0,
      numPoints: parseFloat(Points),
      blStatus: IsActiveStatus,
      blAddNew: addNew,
      strMenuCode: menuCode,
      strLoggedCompany: LogCompanyCode,
      strLoggedLocation: LocationCode,
      strReason: Reason,
      strCreatedBy: LogUserType,
    }


    //loading alert show
    SetLoadingAlert(true)

    if (addNew == true) {
      SetLoadingAlerttitle("Saving...")
    } else {
      SetLoadingAlerttitle("Updating...")
    }

    //*** save/update records */
    const result = await SaveCustomerBundleDetails(customerBundle);

    SetLoadingAlert(false)

    if (result.success) {
      displayAlertMessage("success", result.data)
      ClearItem()
    } else {
      displayAlertMessage("danger", result.data)
    }
  }


  //***save/update end */


  //*** Get user selected row details */
  const GetSelectRow = (e, row, isSelect, rowIndex) => {
    SetCode(row.BUN_CODE)
    getData(row.BUN_CODE)
    setDisabled(true)
    setDisabledCode(true)
    setSaveEnable(false)
    setmodal_xlarge(!modal_xlarge)
    setCrEnable(true)
  }
  //*** End of getSelectedRow function */

  //edit button function
  const handleEdit = e => {
    setDisabled(false)
    setDisabledCode(true)
    setSaveEnable(true)
    SetDeleteEnable(true)
    SetEditEnable(false)
  }

  //new button function
  const handleNew = e => {
    //e.preventDefault()
    ClearItem()
    setShow(false)
    setSaveEnable(true)
    setCrEnable(false)
  }

  //clear fields function
  const ClearItem = () => {
    SetCode("")
    SetBundleName("")


    SetActiveEbill(false)
    SetActiveMobile(false)
    SetActiveStatus(true)

    setDisabledCode(false)
    setDisabled(false)

    setCrEnable(false)
    setcompanyBase([])
    setprofessionBase([])
    setcustomerBase([])
    setdesignationBase([])
    setgender([])
    SetAddNew(true)
    setErrorMsg("")
    SetDeleteEnable(false)
    SetDeleteEnable(false)
    setNullCode(false)
    setSearchdisabled(false)
    SetEditEnable(false)
    setReason("Created")
    SetEditEnable(false)
    setSaveEnable(true)
    setPermissionName("")
    setPermissionPassword("")
    setPermissionNameDisable(false)
    setCodeButton(true)
    setExcelItems([])
    setPoints(0)
    setTimeout(() => {
      setExcelItems([])
    }, 1)
  }

  //********Delete button function */
  const handleDelete = async () => {

    const rowDelete = {
      strMenuCode: menuCode,
      strCode: strCode,
      strLoggedCompany: LogCompanyCode,
      strLoggedLocation: LocationCode,
      strReason: Reason,
      strCreateBy: LogUserType,
    }

    //loading alert show
    SetLoadingAlert(true)
    SetLoadingAlerttitle("Deleting...")

    const result = await DeleteCustomerBundleDetails(rowDelete);

    SetLoadingAlert(false)


    if (result.success) {
      displayAlertMessage("success", result.data)
      ClearItem()

    } else {
      displayAlertMessage("danger", result.data)
    }

  }
  //*********Delete button function end */


  // print Function
  async function handlePrint(option) {
    var option = option

    SetLoadingAlert(true)
    SetLoadingAlerttitle("Generating Report...")

    const ReportURL = window.Links.ReportURL
    await fetch(`${ReportURL}api/CustomerBundle/report/${LogUserType}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
    })
      .then(Response => Response.json())
      .then(responseData => {

        if (responseData.success == true) {
          if (option == "PDF") {
            {
              const msg = responseData.msg
              window.open(
                `${ReportURL}temp_print/${msg.replace("\r\n", "")}.pdf`
              )
            }
          }
          if (option == "XCEL") {
            {
              const msg = responseData.msg
              window.open(
                `${ReportURL}temp_print/${msg.replace("\r\n", "")}.xlsx`
              )
            }
          }
        }
        SetLoadingAlert(false)
      })
  }

  //CODE AUTO GEN
  const AutoGenerateCode = async () => {
    await fetch(`${ApiURL}common/autocode/${menuCode}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
    })
      .then(Response => Response.json())
      .then(responseData => {
        if (responseData.success == true) {
          if (responseData.data.length > 0) {
            SetCode(responseData.data)
            setAutoCode(responseData.data)
          } else {
            setDisabledCode(false)
          }
        }
      })
  }

  //**Permission Check */
  const permission = operation => {
    const permissiondata = {
      strUsername: permissionName,
      strPassword: permissionPassword,
      strLocation: LocationCode,
      strMenuCode: menuCode,
    }

    clearPermissionInputs()

    fetch(`${ApiURL}login/userpermission`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
      body: JSON.stringify(permissiondata),
    })
      .then(Response => {
        if (Response.status == "200") {
          Response.json().then(responseData => {

            let Access = responseData.data.strMenuAccessRight
            let Create = responseData.data.strMenuCreateRight
            let Delete = responseData.data.strMenuDeleteRight
            let Modify = responseData.data.strMenuModifyRight
            let Print = responseData.data.strMenuPrintRight
            let Process = responseData.data.strMenuProcessRight

            if (operation == "Save") {
              if (Create == true) {
                handlesave()
              } else if (Modify == true) {
                handlesave()
              } else {
                if (operation == "Save" && addNew == true) {
                  displayAlertMessage("danger", "This user dosen't have permission to save")
                } else {
                  displayAlertMessage("danger", "This user dosen't have permission to edit")
                }
              }
            } else if (operation == "Delete") {
              if (Delete == true) {
                handleDelete()
              } else {
                displayAlertMessage("danger", "This user don't have permission to delete !")
              }
            } else if (operation == "Print") {
              if (Print == true) {
                setprintoptionShow(true)
              } else {
                displayAlertMessage("danger", "This user don't have permission to print !")
              }
            }
          })
        } else if (Response.status == "400") {
          setDisabled(false)
          setDisabledCode(false)
          clearPermissionInputs()
          displayAlertMessage("danger", "Oops something went wrong !")

        } else if (Response.status == "403") {
          setDisabled(false)
          setDisabledCode(false)
          clearPermissionInputs()
          displayAlertMessage("danger", "You have not Permission to make changes !")

        } else if (Response.status == "404") {
          setDisabled(false)
          setDisabledCode(false)
          clearPermissionInputs()
          displayAlertMessage("danger", "Password or User Name is Invalid !")

        } else {
          ClearItem()
        }
      })
      .catch(error => {
        console.log(error.message)
      })
  }



  //Function for display Alert Messages
  function displayAlertMessage(color, message) {
    setAlertColor(color)
    setAlertMsg(message)
    setShow(true)

    setTimeout(() => {
      setShow(false)
    }, time)
  }



  //handle permission alert
  function handlePermissionAlert(LogUserType, reason, disable, alertShow) {
    setPermissionName(LogUserType)
    setReason(reason)
    setPermissionNameDisable(disable)
    setPermissionAlertShow(alertShow)
  }



  //Clear permission name & password
  function clearPermissionInputs() {
    setPermissionName("");
    setPermissionPassword("");
    setReason("");
  }


  //Handle Favourite Button
  const handleFavourite = async () => {
    var response = await addtoFavourite(menuCode, LogUserType);
  }


  const validateSpecialCharacters = (str) => {
    const specialCharRegex = /[!@#$%^&*(),.?":{}|<>]/;
    return specialCharRegex.test(str);
  };


  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{menuName}</title>
        </MetaTags>
        <Container fluid={true}>
          <Breadcrumb title={parentName} breadcrumbItem={menuName}></Breadcrumb>
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <DPAlert
                    confirm_both={sweetAlertShow}
                    title={menuName}
                    description={AlertDescription}
                    showCancel={true}
                    btnColor={"success"}
                    cancelColor={"danger"}
                    onConfirm={() => {
                      setsweetAlertShow(false)
                      if (AlertConfirmOption == 1) {
                        if (
                          addNew == true &&
                          menuCreate == true &&
                          permissionReasonShow == false
                        ) {
                          handlesave()
                        } else if (
                          addNew == true &&
                          menuCreate == true &&
                          permissionReasonShow == true
                        ) {
                          handlePermissionAlert(LogUserType, "Created", true, true)
                        } else if (
                          addNew == false &&
                          menuModify == true &&
                          permissionReasonShow == false
                        ) {
                          handlesave()
                        } else if (
                          addNew == false &&
                          menuModify == true &&
                          permissionReasonShow == true
                        ) {
                          handlePermissionAlert(LogUserType, "Updated", true, true)
                        } else {
                          setPermissionReasonShow(true)
                          setPermissionAlertShow(true)
                        }
                      } else if (AlertConfirmOption == 2) {
                        handleEdit()
                      } else if (AlertConfirmOption == 3) {
                        history.push('/dashboard')
                      } else if (AlertConfirmOption == 4) {
                        handleNew()
                      } else if (AlertConfirmOption == 6) {
                        if (
                          menuPrint == true &&
                          permissionReasonShow == false
                        ) {
                          setprintoptionShow(true)
                        } else if (
                          menuPrint == true &&
                          permissionReasonShow == true
                        ) {
                          handlePermissionAlert(LogUserType, "Printed", true, true)
                        } else {
                          setPermissionReasonShow(true)
                          setPermissionAlertShow(true)
                        }
                      } else if (AlertConfirmOption == 5) {
                        if (
                          addNew == false &&
                          menuDelete == true &&
                          permissionReasonShow == false
                        ) {
                          handleDelete()
                        } else if (
                          addNew == false &&
                          menuDelete == true &&
                          permissionReasonShow == true
                        ) {
                          handlePermissionAlert(LogUserType, "Deleted", true, true)
                        } else {
                          setPermissionReasonShow(true)
                          setPermissionAlertShow(true)
                        }
                      }
                    }}
                    onCancel={() => {
                      setsweetAlertShow(false)
                    }}
                  />
                  <DPPrintOption
                    confirm_both={printoptionShow}
                    title={menuName}
                    description={permissionAlertTitle}
                    showReason={permissionReasonShow}
                    nameDisable={permissionNameDisable}
                    showCancel={true}
                    cancelColor={"danger"}
                    onConfirmpdf={() => {
                      handlePrint("PDF")
                      setprintoptionShow(false)
                    }}
                    onConfirmxcel={() => {
                      handlePrint("XCEL")
                      setprintoptionShow(false)
                    }}
                    onCancel={() => {
                      setprintoptionShow(false)
                    }}
                  />
                  <DPPermission
                    confirm_both={permissionAlertShow}
                    title={menuName}
                    description={permissionAlertTitle}
                    showReason={permissionReasonShow}
                    nameDisable={permissionNameDisable}
                    showCancel={true}
                    btnColor={"success"}
                    cancelColor={"danger"}
                    AlName={permissionName}
                    AlNameOnchange={e => {
                      let val2 = Text(e.target, 50, true, false, "any", true)
                      setPermissionName(val2)
                    }}
                    AlPassward={permissionPassword}
                    AlPasswardOnchange={e => {
                      let val2 = Text(e.target, 50, true, true, "any", true)
                      setPermissionPassword(val2)
                    }}
                    AlReason={Reason}
                    AlReasonOnchange={e => {
                      let val2 = Text(e.target, 50, true, false, "any", true)
                      setReason(val2)
                    }}
                    onConfirm={() => {
                      setPermissionAlertShow(false)
                      if (AlertConfirmOption == 1) {
                        permission("Save")
                      } else if (AlertConfirmOption == 5) {
                        permission("Delete")
                      } else if (AlertConfirmOption == 6) {
                        permission("Print")
                      }
                    }}
                    onCancel={() => {
                      setPermissionAlertShow(false)
                      clearPermissionInputs()
                    }}
                  />
                  <DPLoadingAlert
                    confirm_both={loadingAlert}
                    title={loadingAlertTitle}
                  />
                  <DPTopToolBar
                    //Help Button
                    helpEnable={helpUrl != "" ? true : false}
                    helpClick={() => {
                      window.open(helpUrl)
                    }}
                    //Favorite Button
                    favoriteEnable={true}
                    favoriteClick={handleFavourite}
                    //New Button
                    newEnable={true}
                    newClick={() => {
                      setAlertDescription("Do you wish to refresh the screen ?")
                      setAlertConfirmOption(4)
                      setsweetAlertShow(true)
                    }}
                    //Save Button
                    saveEnable={saveEnable && isHeadOffice}
                    saveClick={() => {
                      setAlertDescription("Do you wish to save ?")
                      setAlertConfirmOption(1)
                      setsweetAlertShow(true)
                    }}
                    //ProcessButton
                    processEnable={false}
                    processClick={() => {
                      alert("Process")
                    }}
                    //Edit Button
                    editEnable={editEnable && isHeadOffice}
                    editClick={() => {
                      setAlertDescription("Do you wish to edit ?")
                      setAlertConfirmOption(2)
                      setsweetAlertShow(true)
                    }}
                    //Print Button
                    printEnable={true}
                    printClick={() => {
                      setReason("Printed")
                      setAlertDescription("Do you wish to print ?")
                      setAlertConfirmOption(6)
                      setsweetAlertShow(true)
                    }}
                    //Delete Button
                    deleteEnable={deleteEnable}
                    deleteClick={() => {
                      setReason("Deleted")
                      setAlertDescription("Do you wish to delete ?")
                      setAlertConfirmOption(5)
                      setsweetAlertShow(true)
                    }}
                    //Exit Button
                    exitEnable={true}
                    exitClick={() => {
                      setAlertDescription("Do you wish to exit ?")
                      setAlertConfirmOption(3)
                      setsweetAlertShow(true)
                    }}
                  />
                  <Row>
                    <CustomerBundleMasterContent
                      GetSelectRow={GetSelectRow}
                      CodeValue={strCode}
                      CodeonChange={e => {
                        let val1 = Text(
                          e.target,
                          5,
                          true,
                          false,
                          "upper",
                          false
                        )
                        SetCode(val1)
                      }}
                      BundleNameValue={strBundleName}
                      BundleNameOnChange={e => {
                        let val2 = Text(
                          e.target,
                          50,
                          true,
                          false,
                          "any",
                          true
                        )
                        SetBundleName(val2)
                      }}




                      AutoEbill={IsActiveEbill}
                      EbillonChange={() => {
                        SetActiveEbill(!IsActiveEbill)
                      }}
                      AutoMobile={IsActiveMobile}
                      MobileonChange={() => {
                        SetActiveMobile(!IsActiveMobile)
                      }}
                      AutoStatus={IsActiveStatus}
                      StatusonChange={() => {
                        SetActiveStatus(!IsActiveStatus)
                      }}

                      modelTrigger={tog_xlarge}
                      modelOpen={modal_xlarge}
                      allCompany={allCompany}
                      customergroups={customergroups}
                      allDesignation={allDesignation}
                      allProfession={allProfession}
                      setAllCompany={setAllCompany}
                      setAllDesignation={setAllDesignation}
                      setCustomerGroups={setCustomerGroups}
                      setAllProfession={setAllProfession}
                      company={company}
                      customer={customer}
                      designation={designation}
                      profession={profession}
                      setcompanyBase={setcompanyBase}
                      setcustomerBase={setcustomerBase}
                      setdesignationBase={setdesignationBase}
                      setprofessionBase={setprofessionBase}
                      show={show}
                      disabled={disabled}
                      disabledCode={disabledCode}
                      AlertColor={AlertColor}
                      AlertMsg={AlertMsg}
                      CodeOnBlur={e => {
                        getData(e.target.value)
                      }}
                      ErrorMsg={ErrorMsg}
                      menuName={menuName}
                      onButtonClick={e => {
                        AutoGenerateCode()
                        setCodeButton(true)
                      }}
                      btnDisable={codeButton}
                      SearchDisable={searchdisabled}
                      showFileUpload={e => {
                        const file = e.target.files[0]
                        readExcel(file)
                        setvalueUpload(e.target.value)
                      }}
                      valueUpload={valueUpload}
                      genderOnchange={e => {
                        setgender(e["value"])
                      }}
                      gender={gender}
                      setgenderBase={genderBase}
                      minimumpointOnChange={e => {
                        var val1 = Numeric(e.target, 8, 2, false)
                        setPoints(val1)
                      }}
                      minimumpointOnblur={e => {
                        var val1 = DecimalValidation(e.target.value, 0, true, 2)
                        setPoints(val1)
                      }}
                      minimumpointValue={Points}
                      autoCode={autoCode}
                      setgender={setgender}
                      menuCode={menuCode}
                    />
                  </Row>
                  <Row>
                    {crEnable ? (
                      <DPInfoBox
                        createdBy={crBy}
                        createdOn={crDate != '1900-01-01 00:00:00' ? (crDate) ? crDate.replace('T', ' ') : "" : ''}
                        modifiedBy={mdBy}
                        modifiedOn={mdDate != '1900-01-01 00:00:00' ? (mdDate) ? mdDate.replace('T', ' ') : "" : ''}
                      />
                    ) : null}
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default CustomerBundleMaster
